/* eslint formatjs/no-literal-string-in-jsx: "error" */
import React from "react"
import { FlexContainer, Text } from "@carrotfertility/carotene"
import { TextLink } from "../views/atoms/links/TextLink"
import { ICategory } from "../../contentful-types"
import { useReadLearnLinks } from "./shared/ReadLearnLinks"
import { isVideo, ReadLearnArticleItem } from "../../utils/ContentTypes"
import styled from "styled-components"
import { contentTypeMapping } from "./shared/ContentTypeConstants"
import { useIntl } from "react-intl"

type ArticleThumbnailProps = {
  contentType: string
  article: ReadLearnArticleItem
  category: ICategory
}

const StyledThumbnailImage = styled.img`
  min-height: 85px;
  min-width: 85px;
  max-height: 85px;
  max-width: 85px;
  border-radius: 8px;
  position: relative;
`

function ThumbnailImage({ article }: { article: ReadLearnArticleItem }): JSX.Element {
  const thumbnailUrl = article.fields?.thumbnail?.fields?.file?.url
  const intl = useIntl()
  return isVideo(article) ? (
    <FlexContainer alignItems={"center"} justifyContent="center">
      <StyledThumbnailImage
        src={thumbnailUrl}
        alt={intl.formatMessage({ defaultMessage: "video-image", description: "thumbnail image for video" })}
      />
      <img
        height={"40px"}
        width={"40px"}
        src="/images/icon-video-play-button.svg"
        alt={intl.formatMessage({ defaultMessage: "video play button", description: "play button icon for video" })}
        style={{
          position: "absolute"
        }}
      />
    </FlexContainer>
  ) : (
    <StyledThumbnailImage
      src={thumbnailUrl}
      alt={intl.formatMessage({ defaultMessage: "article-image", description: "thumbnail image for article" })}
    />
  )
}

export default function ArticleThumbnail({ contentType, article, category }: ArticleThumbnailProps): JSX.Element {
  const { articleLink } = useReadLearnLinks({ category, article })
  const intl = useIntl()
  return (
    <TextLink to={articleLink} underline={false}>
      <FlexContainer gap={"16px"}>
        <ThumbnailImage {...{ article }} />
        <FlexContainer direction={"column"}>
          <Text variant={"caps"} color={"black40"} size={"11px"} weight={"semibold"}>
            {intl.formatMessage(contentTypeMapping[contentType]?.name)}
          </Text>
          <Text color={"black80"} weight={"semibold"} size={"16px"}>
            {article?.fields?.title}
          </Text>
        </FlexContainer>
      </FlexContainer>
    </TextLink>
  )
}
